import { getRemoteConfig, getValue, fetchAndActivate } from 'firebase/remote-config';
import app from './firebase';

const remoteConfig = getRemoteConfig(app);
// remoteConfig.settings.minimumFetchIntervalMillis = 5000;

export async function fetchRemoteConfigFields(
  fields: string[] = []
): Promise<{ [key: string]: string | number | boolean }> {
  try {
    await fetchAndActivate(remoteConfig);

    const configValues: { [key: string]: string | number | boolean } = {};

    fields.forEach((field) => {
      const value = getValue(remoteConfig, field);

      let configValue: string | number | boolean;

      if (!isNaN(Number(value.asString()))) {
        configValue = value.asNumber(); // Convert to number if it's numeric
      } else if (
        value.asString().toLowerCase() === 'true' ||
        value.asString().toLowerCase() === 'false'
      ) {
        configValue = value.asBoolean(); // Convert to boolean if it looks like 'true' or 'false'
      } else {
        configValue = value.asString(); // Fallback to string
      }

      configValues[field] = configValue;
    });

    return configValues;
  } catch (err) {
    console.error('Error fetching remote config:', err);
    return {};
  }
}
